webpackJsonp([180975309979847],{

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tree.d3496d64.png";

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Työ = function Työ() {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                margin: '0 auto',
	                width: '80%',
	                display: 'grid',
	                gridTemplateColumns: '2fr 1fr',
	                gridGap: '5%',
	                textAlign: 'justify',
	                fontSize: '1.1vw',
	                lineHeight: '1.2'
	
	            } },
	        _react2.default.createElement(
	            'div',
	            { className: 'palvelu-text' },
	            _react2.default.createElement(
	                'h2',
	                { style: {
	                        color: '#B4BB2D',
	                        marginLeft: '3%'
	
	                    } },
	                ' ',
	                _react2.default.createElement(
	                    'span',
	                    { className: 'quote' },
	                    '\u201C'
	                ),
	                ' Ty\xF6nantajan ja ty\xF6ntekijan yhteinen etu'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Tyo\u0308terveyshammashoito on on yleistynyt viime vuosien aikana. Siita\u0308 hyo\u0308tyva\u0308t seka\u0308 tyo\u0308nantaja, etta\u0308 tyo\u0308ntekija\u0308. Kun hammashoidosta tehda\u0308a\u0308n kirjallinen sopi- mus, on se ta\u0308ysin verova\u0308hennyskelpoista yrityksille ja samalla veroton etu myo\u0308s tyo\u0308ntekija\u0308lle. Suun terveys on osa kokonaisvaltaista terveytta\u0308. Tutkimukset osoit- tavat, etta\u0308 aktiivinen hammashoito va\u0308henta\u0308a\u0308 sairauspoissaoloja. Sopimus tyo\u0308paik- kahammashoidosta on siis seka\u0308 tyo\u0308nantajan etta\u0308 tyo\u0308ntekija\u0308n etu.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                ' Sopimus tyo\u0308terveyshammashoidosta voidaan tehda\u0308 siten, etta\u0308 siina\u0308 ma\u0308a\u0308ritella\u0308a\u0308n korvattavat palvelut ja korvauksen laajuus. Yritys voi itse pa\u0308a\u0308tta\u0308a\u0308, korvaako se hammashoidon kokonaan vai osittain. Etu tulee olla ka\u0308yto\u0308ssa\u0308 koko henkilo\u0308sto\u0308lla\u0308, mutta sita\u0308 voidaan rajoittaa tyo\u0308suhteen pituuden mukaan.'
	            ),
	            _react2.default.createElement(
	                'h4',
	                { style: {
	                        color: '#B4BB2D',
	                        marginLeft: '3%'
	
	                    } },
	                'Ota yhteytta\u0308, niin kerromme sinulle lisa\u0308a\u0308!'
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'review' },
	            _react2.default.createElement('img', { src: __webpack_require__(473) })
	        )
	    );
	};
	
	exports.default = Työ;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tyo-js-77ec9ffc09751b612958.js